import { render, staticRenderFns } from "./hijry-cmp.vue?vue&type=template&id=f3f5dfa0&"
import script from "./hijry-cmp.vue?vue&type=script&lang=js&"
export * from "./hijry-cmp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports